import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import { GrainOverlay } from "@/components/portfolio/GrainOverlay";
import { Navbar } from "@/components/portfolio/Navbar";
import { Hero } from "@/components/portfolio/Hero";
import { About } from "@/components/portfolio/About";
import { VideoSection } from "@/components/portfolio/VideoSection";
import { Manifesto } from "@/components/portfolio/Manifesto";
import { ClientMarquee } from "@/components/portfolio/ClientMarquee";
import { Experience } from "@/components/portfolio/Experience";
import { Skills } from "@/components/portfolio/Skills";
import { Recognition } from "@/components/portfolio/Recognition";
import { Writing } from "@/components/portfolio/Writing";
import { Contact } from "@/components/portfolio/Contact";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-[#FBFAF7] text-[#1A1A18] antialiased">
      <GrainOverlay />
      <Navbar />
      <main>
        <Hero />
        <About />
        <VideoSection />
        <Manifesto />
        <ClientMarquee />
        <Experience />
        <Skills />
        <Recognition />
        <Writing />
        <Contact />
      </main>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid rgba(0,0,0,0.1)",
            color: "#1A1A18",
            fontFamily: "'Outfit', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
